exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "md-toolbar.pie {\n\tbackground-color: #c0c0c0;\n\ttop:auto;\n\tbottom:0px;\n\tleft:auto;\n\tposition:fixed;\n}\n\n.app-input-dian-pie {\n  font-size: 28px;\n  color: #515151;\n  text-align:right;\n  padding-left: 10px;\n}\n\n\n.app-toolbar-filler {\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 auto;\n          flex: 1 1 auto;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GIT/F260V3/ingreso/ng_ingresosimple260/Simple260Ingreso/src/app/components/pie/pie.component.css
// module id = ../../../../../src/app/components/pie/pie.component.css
// module chunks = main